const COOKIE_NAME = 'token';

export const getToken = (): string | null => {
  return localStorage.getItem(COOKIE_NAME);
};

export const storeJWT = (token: string): void => {
  localStorage.setItem(COOKIE_NAME, token);
};
